<template>
  <div>
    <a-modal v-model="visible" width="720px" title="镜像回滚" @cancel="onCancel">
      <template slot="footer">
        <a-button key="cancel" @click="onCancel"> 取消 </a-button>
        <a-button key="back" v-tc="{ name: '不回滚，仅退回流程' }" :disabled="loading" @click="onOnlyBack"> 不回滚，仅退回流程 </a-button>
        <a-button key="submit" v-tc="{ name: '确认回滚' }" type="primary" :loading="loading" @click="onRollback"> 确认回滚 </a-button>
      </template>
      <a-table size="middle" class="steps_table" :pagination="false" :columns="columns" :data-source="versionData" :row-key="(_, index) => index">
        <span slot="version" slot-scope="text, record">
          <a-select v-model="record.version" style="width: 100%">
            <a-select-option v-for="(item, key) in record.versions" :key="key" :value="item.version_id">{{ item.version }}</a-select-option>
          </a-select>
        </span>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { serviceHistoryVersion, serviceRollback } from '@/api/project/workflow';

const columns = [
  {
    width: 300,
    title: '服务名称',
    key: 'service_name',
    dataIndex: 'service_name'
  },
  {
    width: 100,
    title: '当前版本',
    key: 'current_version',
    dataIndex: 'current_version'
  },
  {
    width: 160,
    key: 'version',
    title: '回滚版本',
    dataIndex: 'version',
    scopedSlots: { customRender: 'version' }
  }
];
export default {
  data() {
    return {
      columns,
      loading: false,
      visible: false,
      versionData: [],
      workflowId: null,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  methods: {
    /**
     * 点击打开
     * @param {*} workflowId
     */
    async onOpen(workflowId, stepId) {
      this.workflowId = workflowId;
      // 需求交付流程的产品、运营时无需弹出回滚操作
      if ([127, 103, 104, 105, 106].includes(stepId)) {
        // 如果流程没有成功部署的记录，则跳过
        this.$emit('back'); // 无需回滚镜像版本时，直接回调父组件流转接口
        return;
      }
      // 获取历史版本
      try {
        const { code, data, message } = await serviceHistoryVersion({ workflow_id: this.workflowId, project_id: this.projectId });
        if (code === 2000) {
          // 如果流程有成功部署的记录，则弹出流程回滚模态框
          if (data.items.length > 0) {
            this.visible = true;
            this.versionData = data.items.map(item => {
              return { ...item, version: item.versions[0].version_id };
            });
          } else {
            // 如果流程没有成功部署的记录，则跳过
            this.$emit('back'); // 无需回滚镜像版本时，直接回调父组件流转接口
            this.$message.success('当前流程没有需要回滚的镜像');
            // console.log('流程未部署，无需回滚镜像');
          }
        } else {
          this.$message.warning(message);
        }
      } catch (error) {
        this.$message.warning(error);
      }
    },

    /**
     * 点击取消
     */
    onCancel() {
      this.visible = false;
      this.versionData = [];
      this.$emit('cancle');
    },

    /**
     * 仅退回
     */
    onOnlyBack() {
      this.visible = false;
      // 调用父组件流程退回(需确认父组件是否传递该方法)
      this.$emit('back');
    },

    /**
     * 退回并回滚镜像
     */
    async onRollback() {
      this.loading = true;
      // 调用父组件流程退回(需确认父组件是否传递该方法)
      this.$emit('back');

      // 调用回滚镜像版本接口
      const services = this.versionData.map(item => {
        return {
          service_id: item.service_id,
          version_id: item.version,
          release_service_id: item.release_service_id
        };
      });
      serviceRollback({ workflow_id: this.workflowId, env: this.env, services: services })
        .then(() => {
          this.loading = false;
          this.visible = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
